import * as React from 'react';
import './sport.scss';

interface ISport {
  place: number;
  sport: string;
  src: string;
}

const Sport: React.SFC<ISport> = ({ place, sport, src }) => (
  <React.Fragment>
    <div className="sport">
      <img src={`${src}`} />
      <h3 className="c-sport__name"> {sport}</h3>
      <span>{place}</span>
    </div>
  </React.Fragment>
);

export default Sport;



// WEBPACK FOOTER //
// ./src/containers/result/components/Sport.tsx